module.exports = __webpack_public_path__ + "static/media/img.4fbff4b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/NotFound/img.png
// module id = 693
// module chunks = 0